import { createSelector } from 'reselect';

import getBuffer from './getBuffer';
import getBufferReadyToApply from './getBufferReadyToApply';
import { DELIVERY_SALE_TYPES } from '../constants/saleType';

export default createSelector(
  [getBuffer, getBufferReadyToApply],
  (buffer, bufferReadyToApply) =>
    bufferReadyToApply &&
    !!buffer.saleType &&
    DELIVERY_SALE_TYPES.includes(buffer.saleType),
);
